import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

export type ActionLog = {
  id: string
  timestamp: number
  action: string
  payload: any
  state: any
}

type DebugState = {
  actionHistory: ActionLog[]
  maxHistorySize: number
  isEnabled: boolean
}

type DebugActions = {
  logAction: (action: string, payload: any, state: any) => void
  clearHistory: () => void
  toggleDebug: () => void
}

export const useDebugStore = create<DebugState & DebugActions>()(
  devtools(
    (set, get) => ({
      actionHistory: [],
      maxHistorySize: 100,
      isEnabled: true,

      logAction: (action, payload, state) => {
        if (!get().isEnabled) return

        const newLog: ActionLog = {
          id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
          timestamp: Date.now(),
          action,
          payload,
          state,
        }

        set((state) => ({
          actionHistory: [newLog, ...state.actionHistory].slice(0, state.maxHistorySize),
        }))
      },

      clearHistory: () => {
        set({ actionHistory: [] })
      },

      toggleDebug: () => {
        set((state) => ({ isEnabled: !state.isEnabled }))
      },
    }),
    {
      name: 'debug-store',
    },
  ),
)
